// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tpl {
  --tpl-bg: #0b1220;
  --tpl-surface: #0b1f33;
  --tpl-surface-2: #16324d;
  --tpl-text: #e8eef8;
  --tpl-muted: #9fb0c8;
  --tpl-accent: #7dd3fc;
  --tpl-primary: #1d4ed8;
  --tpl-primary-soft: #93c5fd;
  --tpl-border: rgba(125, 211, 252, 0.22);
  --tpl-pill-video-bg: #064e3b;
  --tpl-pill-video-fg: #6ee7b7;
  --tpl-pill-self-bg: #1e3a5f;
  --tpl-pill-self-fg: #93c5fd;
  --tpl-warn: #fbbf24;
  --tpl-err: #fca5a5;
  --tpl-bar: #16324d;

  max-width: 920px;
  margin: 0 auto;
  padding: 24px 16px 80px;
  color: var(--tpl-text);
  background: var(--tpl-bg);
  min-height: 100%;
  box-sizing: border-box;
}

.tpl--light {
  --tpl-bg: #f4f7fb;
  --tpl-surface: #ffffff;
  --tpl-surface-2: #e8eef6;
  --tpl-text: #0f172a;
  --tpl-muted: #475569;
  --tpl-accent: #0369a1;
  --tpl-primary: #1d4ed8;
  --tpl-primary-soft: #2563eb;
  --tpl-border: rgba(15, 23, 42, 0.12);
  --tpl-pill-video-bg: #d1fae5;
  --tpl-pill-video-fg: #047857;
  --tpl-pill-self-bg: #dbeafe;
  --tpl-pill-self-fg: #1d4ed8;
  --tpl-warn: #b45309;
  --tpl-err: #b91c1c;
  --tpl-bar: #dbe3ef;
}

.tpl__kicker {
  letter-spacing: 0.18em;
  text-transform: uppercase;
  font-size: 0.68rem;
  color: var(--tpl-accent);
  margin: 0 0 6px;
}

.tpl__head h1 {
  margin: 0 0 8px;
  font-size: 1.7rem;
  color: var(--tpl-text);
}

.tpl__lede {
  max-width: 40rem;
  color: var(--tpl-muted);
  line-height: 1.45;
}

.tpl__prep {
  margin-top: 12px;
  background: var(--tpl-primary);
  color: #fff;
  border: 0;
  border-radius: 999px;
  padding: 10px 18px;
  font-weight: 700;
}

.tpl__prep:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.tpl__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 14px;
  margin-top: 22px;
}

.tpl-card {
  background: var(--tpl-surface);
  border: 1px solid var(--tpl-border);
  border-radius: 16px;
  padding: 16px;
  color: var(--tpl-text);
}

.tpl-card__top {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: flex-start;
}

.tpl-card h2 {
  margin: 0;
  font-size: 1.05rem;
  color: var(--tpl-text);
}

.tpl-pill {
  font-size: 0.68rem;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}

.tpl-pill.is-video {
  background: var(--tpl-pill-video-bg);
  color: var(--tpl-pill-video-fg);
}

.tpl-pill.is-self {
  background: var(--tpl-pill-self-bg);
  color: var(--tpl-pill-self-fg);
}

.tpl-card__desc {
  margin: 8px 0 0;
  color: var(--tpl-muted);
  font-size: 0.9rem;
  line-height: 1.4;
}

.tpl-bar {
  height: 6px;
  background: var(--tpl-bar);
  border-radius: 99px;
  margin: 12px 0 8px;
  overflow: hidden;
}

.tpl-bar span {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, #2563eb, #38bdf8);
}

.tpl-card__score,
.tpl-card__meta {
  margin: 0;
  font-size: 0.82rem;
  color: var(--tpl-muted);
}

.tpl-card__score em {
  color: var(--tpl-warn);
  font-style: normal;
}

.tpl-card__drills {
  margin: 10px 0 0;
  padding-left: 1.1em;
  font-size: 0.78rem;
  color: var(--tpl-muted);
}

.tpl-card__point {
  display: flex;
  gap: 6px;
  margin-top: 10px;
  font-size: 0.68rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--tpl-accent);
}

.tpl__err {
  color: var(--tpl-err);
}

.tpl__foot {
  margin-top: 28px;
}

.tpl__foot a {
  color: var(--tpl-accent);
}
`, "",{"version":3,"sources":["webpack://./src/pages/tactical/TacticalPatternLibrary.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,uCAAuC;EACvC,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;;EAElB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;EACpC,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oDAAoD;AACtD;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".tpl {\n  --tpl-bg: #0b1220;\n  --tpl-surface: #0b1f33;\n  --tpl-surface-2: #16324d;\n  --tpl-text: #e8eef8;\n  --tpl-muted: #9fb0c8;\n  --tpl-accent: #7dd3fc;\n  --tpl-primary: #1d4ed8;\n  --tpl-primary-soft: #93c5fd;\n  --tpl-border: rgba(125, 211, 252, 0.22);\n  --tpl-pill-video-bg: #064e3b;\n  --tpl-pill-video-fg: #6ee7b7;\n  --tpl-pill-self-bg: #1e3a5f;\n  --tpl-pill-self-fg: #93c5fd;\n  --tpl-warn: #fbbf24;\n  --tpl-err: #fca5a5;\n  --tpl-bar: #16324d;\n\n  max-width: 920px;\n  margin: 0 auto;\n  padding: 24px 16px 80px;\n  color: var(--tpl-text);\n  background: var(--tpl-bg);\n  min-height: 100%;\n  box-sizing: border-box;\n}\n\n.tpl--light {\n  --tpl-bg: #f4f7fb;\n  --tpl-surface: #ffffff;\n  --tpl-surface-2: #e8eef6;\n  --tpl-text: #0f172a;\n  --tpl-muted: #475569;\n  --tpl-accent: #0369a1;\n  --tpl-primary: #1d4ed8;\n  --tpl-primary-soft: #2563eb;\n  --tpl-border: rgba(15, 23, 42, 0.12);\n  --tpl-pill-video-bg: #d1fae5;\n  --tpl-pill-video-fg: #047857;\n  --tpl-pill-self-bg: #dbeafe;\n  --tpl-pill-self-fg: #1d4ed8;\n  --tpl-warn: #b45309;\n  --tpl-err: #b91c1c;\n  --tpl-bar: #dbe3ef;\n}\n\n.tpl__kicker {\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  font-size: 0.68rem;\n  color: var(--tpl-accent);\n  margin: 0 0 6px;\n}\n\n.tpl__head h1 {\n  margin: 0 0 8px;\n  font-size: 1.7rem;\n  color: var(--tpl-text);\n}\n\n.tpl__lede {\n  max-width: 40rem;\n  color: var(--tpl-muted);\n  line-height: 1.45;\n}\n\n.tpl__prep {\n  margin-top: 12px;\n  background: var(--tpl-primary);\n  color: #fff;\n  border: 0;\n  border-radius: 999px;\n  padding: 10px 18px;\n  font-weight: 700;\n}\n\n.tpl__prep:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.tpl__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 14px;\n  margin-top: 22px;\n}\n\n.tpl-card {\n  background: var(--tpl-surface);\n  border: 1px solid var(--tpl-border);\n  border-radius: 16px;\n  padding: 16px;\n  color: var(--tpl-text);\n}\n\n.tpl-card__top {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.tpl-card h2 {\n  margin: 0;\n  font-size: 1.05rem;\n  color: var(--tpl-text);\n}\n\n.tpl-pill {\n  font-size: 0.68rem;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n.tpl-pill.is-video {\n  background: var(--tpl-pill-video-bg);\n  color: var(--tpl-pill-video-fg);\n}\n\n.tpl-pill.is-self {\n  background: var(--tpl-pill-self-bg);\n  color: var(--tpl-pill-self-fg);\n}\n\n.tpl-card__desc {\n  margin: 8px 0 0;\n  color: var(--tpl-muted);\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n.tpl-bar {\n  height: 6px;\n  background: var(--tpl-bar);\n  border-radius: 99px;\n  margin: 12px 0 8px;\n  overflow: hidden;\n}\n\n.tpl-bar span {\n  display: block;\n  height: 100%;\n  background: linear-gradient(90deg, #2563eb, #38bdf8);\n}\n\n.tpl-card__score,\n.tpl-card__meta {\n  margin: 0;\n  font-size: 0.82rem;\n  color: var(--tpl-muted);\n}\n\n.tpl-card__score em {\n  color: var(--tpl-warn);\n  font-style: normal;\n}\n\n.tpl-card__drills {\n  margin: 10px 0 0;\n  padding-left: 1.1em;\n  font-size: 0.78rem;\n  color: var(--tpl-muted);\n}\n\n.tpl-card__point {\n  display: flex;\n  gap: 6px;\n  margin-top: 10px;\n  font-size: 0.68rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--tpl-accent);\n}\n\n.tpl__err {\n  color: var(--tpl-err);\n}\n\n.tpl__foot {\n  margin-top: 28px;\n}\n\n.tpl__foot a {\n  color: var(--tpl-accent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
